import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
import Factory1 from "../../assets/hat/31. 캘리포니아주 스탁톤 본사.jpg";
import Factory2 from "../../assets/hat/32. 텍사스주 달라스 공장  밀라노.jpg";
import Factory3 from "../../assets/hat/33. 중국 상해 공장  SGA.jpg";
import Factory4 from "../../assets/hat/34. 멕시코 공장  훠거햇.jpg";
import Factory5 from "../../assets/hat/35. 멕시코 리테일샾  카보햇.jpg";
import Hat1 from "../../assets/hat/36. 미국법인 모자.jpg";
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const SalesCorporation3 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation">
                <div className="kor">위탁경영사업장</div>
                <div className="eng">Indirect Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/HatBusiness/SalesCorporation3">
                <div className="kor">돌프만퍼시픽 ㈜</div>
                <div className="eng">Dorfman Milano Company</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">AJM</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation2">
                  <div className="kor">아웃도아 캡 컴퍼니㈜</div>
                  <div className="eng">Outdoor Cap Co., Inc.</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation3">
                  <div className="kor">돌프만퍼시픽 ㈜</div>
                  <div className="eng">Dorfman Milano Company</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"돌프만"}
              titleeng={"Dorfman Milano Company"}
              link={"http://www.dorfmanmilano.com/"}
            />
            <div className="page-text">Dorfman Milano Company</div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">캘리포니아 스탁톤 본사</div>
                <div className="eng">Headquarters in Stockton, California</div>
              </div>
            </S.ImgHolderFullsize>

            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">텍사스주 달라스 공장 / 밀라노</div>
                  <div className="eng">
                    Milano Hat / Factory in Dallas, Texas
                  </div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Factory3} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">중국 상해 공장 / SGA</div>
                  <div className="eng">
                    Shanghai Gausha Accessory Co., Ltd.
                    <br />/ Factory in Shanghai, China
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>
            <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Factory4} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">멕시코 공장 / 훠거햇</div>
                  <div className="eng">
                    Import-Export Fergar S.A. de C.V.
                    <br />/ Factory in Mexico
                  </div>
                </div>
              </S.ImgHolderHarf>

              <S.ImgHolderHarf>
                <img src={Factory5} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">멕시코 리테일샆 / 카보햇</div>
                  <div className="eng">
                    Arte En Ropa S. De R.L. De C.V.
                    <br />/ Retail store in Mexico
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex>

            <PageTitle
              titleko={"주요생산제품"}
              titleeng={"Major Production Products"}
            />
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">Dorfman Milano Company 법인개요</div>
                    <div className="eng">
                      Company Profile of Dorfman Milano Company
                    </div>
                  </div>
                  <div className="kor">
                    법인 설립: 1921년
                    <br />
                    영안 합자: 1993년
                    <br />
                    중국 Shanghai Gausha Accessory Co., Ltd.(SGA) 합자: 2003년
                    <br />
                    Mliano Hat Co., Inc.(밀라노햇) 합병: 2004년
                    <br />
                    Arte En Ropa S. De R.L. De C.V.(카보햇) 합자: 2006년
                    <br />
                    Import-Export Fergar S.A. de C.V.(훠거햇) 합자: 2011년
                  </div>
                  <div className="eng">
                    Establishment : 1921
                    <br />
                    Joint venture with YoungAn : 1993
                    <br />
                    J/V with Shanghai Gausha Accessory Co., Ltd. : 2003
                    <br />
                    Merged with Milano Hat Co., Inc. : 2004
                    <br />
                    J/V with Arte En Ropa S. De R.L. De C.V. : 2006
                    <br />
                    J/V with Import-Export Fergar S.A. de C.V. : 2011
                  </div>
                </div>
              </div>
              <div className="kor">
                ※ 캘리포니아주 스탁톤 본사 / 텍사스주 달라스 공장 / 중국 상해 및
                멕시코 공장
                <br />
                ※ 종합모자 판매업체
                <br />
                ※ 다양한 브랜드의 패션제품(햇 류)을 미국 포함, 전 세계
                리테일시장에 판매
                <br />
                ※ 20여 곳 이상의 전 세계 공급처에서 천모자, 스트로햇, 휄트햇 등
                다양한 <br />
                스타일의 모자 취급
              </div>
              <div className="eng">
                ※ Headquarters in Stockton, California / Factory in Dallas,
                Texas
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;/ Shanghai and Mexico factories
                <br />
                ※ Comprehensive hat sales company
                <br />
                ※ Selling various fashion products(hat related) with various
                brands
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;to retail markets of the world,
                including U.S.A.
                <br />
                ※ Handling hats in various styles such as cloth hats, straw
                hats, felt hats,
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;etc. with more than 20 suppliers in the
                world
              </div>
            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default SalesCorporation3;
